import React, {useState, useEffect} from "react";
import {DIRECTIONS} from "../carousel.consts";

export const CarouselComposer = (Widget) => ((props) => {
  const childrenCount: Number = React.Children.count(props.children);

  if (!props.children || childrenCount <= 0) {
    return null;
  }

  if (childrenCount === 1) {
    return props.children;
  }

  const [direction, setDirection] = useState(DIRECTIONS.next);
  const [sliding, setSliding] = useState(false);
  const [position, setPosition] = useState(props.initialIndex || 0);

  useEffect(() => {
    setPosition(props.initialIndex || 0);
  }, [props.initialIndex])


  const onSlide: Function = (direction: DIRECTIONS, index: Number) => {
    let nextPosition = index;

    if (direction === DIRECTIONS.next) {
      nextPosition = position === childrenCount - 1 ? 0 : position + 1;
    }

    if (direction === DIRECTIONS.previous) {
      nextPosition = position === 0 ? childrenCount - 1 : position - 1;
    }

    setPosition(nextPosition);
    setDirection(direction);
    setSliding(true);

    setTimeout(() => setSliding(false), 0);

    props.onChange && props.onChange(nextPosition, direction);
  };

  useCarouselAutoSlide(onSlide, props.autoSwitchTimeMS);


  const onCalcOrder: Function = (index: Number, position: Number, count: Number) => {
    const shiftedIndex = index + 1;
    const isBiggerThenLength = (shiftedIndex - position > count - 1);
    const isNegative = (shiftedIndex - position < 0);
    const order = isBiggerThenLength || isNegative ? count - Math.abs(shiftedIndex - position) : shiftedIndex - position;

    return order;
  };

  const newProps = {
    childrenCount: childrenCount,
    direction,
    sliding,
    position,
    onSlide: (direction, index) => onSlide(direction, index),
    onCalcOrder: (index, position, childrenCount) => onCalcOrder(index, position, childrenCount),
    ...props
  };


  return (
    <Widget {...newProps} />
  );
});


export const useCarouselAutoSlide = (onSlide, time) => {
  React.useEffect(() => {
    let interval;
    if (time > 0) {
      interval = setInterval(() => {
        onSlide(DIRECTIONS.next);
      }, time);
    }

    return () => clearInterval(interval);
  }, [onSlide, time]);
};